import { trackForwarded } from "@/analytics";
import { forwardWidgetEvent } from "@/analytics/forward";
import { getChatApi } from "@/chatApi";

import { setupGoogleAnalytics4, trackGA4Event } from "./googleAnalytics";
import { TomisEventName } from "./types";
export { TomisEvent, type TomisEventName } from "./types";
import pkg from "../../package.json";

/** Initialize tracking for the chat widget.
 *
 * This function will setup Google Analytics 4 for tracking events.
 */
export function initializeTracking() {
  setupGoogleAnalytics4();
}

/** Track chat widget event across all tracking platforms
 * - Google Analytics 4
 *
 * If in test_mode, no events will be tracked
 */
export function trackEvent(
  eventName: TomisEventName,
  eventParams: Record<string, any> = {},
) {
  /** Ensure we aren't directly modifying payload */
  const params = { ...eventParams };

  const chat = getChatApi().chat;

  params.site = chat.id;
  params.status = chat.status;
  params.release = pkg.version;
  params.feedback = chat.feedback;
  if (params.embed === undefined) {
    params.embed = chat.embed;
  }
  // Get information from users browser
  params.browser_url = window.location.href;
  params.browser_info = window.navigator.userAgent;
  params.browser_screen_width = window.screen.width;
  params.browser_screen_height = window.screen.height;
  params.browser_language = window.navigator.language;

  if (chat.test_mode) {
    console.groupCollapsed(`Event: ${eventName}`);
    for (const key in params) {
      console.log(`${key}: ${params[key]}`);
    }
    console.groupEnd();
    return;
  } else {
    trackGA4Event(eventName, params);
    for (const event of forwardWidgetEvent(eventName, params)) {
      trackForwarded(event);
    }
  }
}
